import React from 'react'
import { Box, BoxProps, useDisclosure } from '@chakra-ui/react'
import { MaintenanceModal } from '@/components/MaintenanceModal'

type GuardedExternalLinkProps = {
  href: string
  children: React.ReactNode
  openInNewTab?: boolean
} & BoxProps

export const GuardedExternalLink = ({
  href,
  children,
  openInNewTab = true,
  ...boxProps
}: GuardedExternalLinkProps): JSX.Element => {
  const disclosure = useDisclosure()

  const isUnderMaintenance =
    process.env.NEXT_PUBLIC_IS_UNDER_MAINTENANCE === 'true'

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault()

    if (isUnderMaintenance) {
      disclosure.onOpen()
    } else {
      if (openInNewTab) {
        window.open(href, '_blank', 'noopener,noreferrer')
      } else {
        window.location.href = href
      }
    }
  }

  return (
    <>
      <Box
        as="button"
        onClick={handleClick}
        {...boxProps}
        sx={{
          bg: 'transparent',
          border: 'none',
          cursor: 'pointer',
          textAlign: 'center',
          ...boxProps.sx,
        }}
      >
        {children}
      </Box>
      <MaintenanceModal disclosure={disclosure} />
    </>
  )
}
